type PlanNavigationListener = (screen: string) => void;

const listeners = new Set<PlanNavigationListener>();

export function subscribeToPlanNavigation(listener: PlanNavigationListener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function notifyPlanNavigation(screen: string): void {
  listeners.forEach((listener) => listener(screen));
}
